export enum ReportTypes {
    totalReport = 'total-report',
    projectsOverview = 'projects-overview',
    chart = 'chart',
    pieChart = 'piechart',
    matrix = 'matrix',
    tableReport = 'table',
    news = 'news',
}
